import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import { TariffForm } from 'Services/ProductManagement/Features/Tariff/Components/TariffForm'
import useSingleTariff from 'Services/ProductManagement/Features/Tariff/Hooks/useSingleTariff'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function TariffCreatePage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`
  const previousLocation = usePreviousLocation(baseUrl)
  const { singleLoading, submitLoading } = useSingleTariff(undefined)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`,
      link: baseUrl
    },
    {
      title: t`Create new tariff`
    }
  ]

  const isLoading = singleLoading === 'pending'

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new tariff`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <TariffForm successBaseUrl={previousLocation} submitLoading={submitLoading} />
      </WithLoader>
    </Box>
  )
}
